var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcHome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Copy-3",
    transform: "translate(-141.000000, -70.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.195914,71.3668629 L141.625914,79.4701123 C141.226379,79.8478871 141,80.3734897 141,80.923346 L141,88.9307886 L148.845826,88.9307886 L148.845826,85.109855 C148.845826,83.605335 150.06548,82.3856805 151.57,82.3856805 L151.57,82.3856805 C153.07452,82.3856805 154.294174,83.605335 154.294174,85.109855 L154.294174,88.9307886 L162.14,88.9307886 L162.14,80.923346 C162.14,80.3734897 161.913621,79.8478871 161.514086,79.4701123 L152.944086,71.3668629 C152.173072,70.6378412 150.966928,70.6378412 150.195914,71.3668629 Z",
    id: "onboardingIcHome"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcHome);
export default __webpack_public_path__ + "static/media/onboardingIcHome.2b59c3ed3a8b30f6bce088ec0cd141f1.svg";
export { ForwardRef as ReactComponent };